import Vue from 'vue'
import * as Sentry from '@sentry/vue'
import { Integrations } from '@sentry/tracing'
import { environmentName, isStaging, isProduction } from '~utils/env-provider'
import { getMetaEnvString } from '~utils/meta'

const setErrorHandling = (): void => {
  Sentry.init({
    Vue,
    dsn: 'https://cf99ad088ab94f58af15bf9fe39dc75e@o511855.ingest.sentry.io/5716626',
    integrations: [
      new Integrations.BrowserTracing(),
    ],
    tracesSampleRate: isProduction ? 0.2 : 0.0,
    logErrors: !(isStaging || isProduction), // if true, Sentry will call Vue's logError function as well
    release: getMetaEnvString('GIT_SHA'),
    environment: environmentName,
    beforeSend(event) {
      // If not on production or staging, don't send to Sentry to avoid noise
      if (!(isProduction || isStaging)) {
        return null
      }

      return event
    },
  })
}

export default setErrorHandling
